//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '../css/style.css'

export default {
    props: [],
    data() {
        return {
            form: {
                code: '',
                captcha: ''
            },
            code: '',

            msgBtnDisabled: false,
            msgBtnText: '获取短信验证码',
            interval: null
        }
    },
    computed: {
        mobile() {
            return this.getQuery('mobile')
        },
        guaranteeid() {
            return this.getQuery('guaranteeid')
        },
    },
    methods: {
        submitHandler() {
            if(this.code !== this.form.code) {
                ShowMsg.call(this, '验证码不正确', 'error');
                this.createCode();
                return;
            };
            if(!this.form.captcha) {
                ShowMsg.call(this, '请输入手机验证码', 'error');
                return;
            };
            this.$get(this.getStore('confUrl') + '/viewsample', {
                mobile: this.mobile,
                captcha: this.form.captcha,
                guaranteeid: this.guaranteeid
            }, (data) => {
                this.setStore({
                    'confirmSample': data.sample
                });
                this.goto({
                    path: './form',
                    query: {
                        src: data.url,
                        rowguid: data.rowguid
                    }
                })
            })
        },
        createCode:function() {
            //先清空验证码的输入
            var code = "";
            //验证码的长度
            var codeLength = 4;
            //随机数
            var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h',
                'i', 'j', 'k','l', 'm', 'n', 'o','p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y',
                'z');
            for (var i = 0; i < codeLength; i++) {
                //取得随机数的索引（0~35）
                var index = Math.floor(Math.random() * 36);
                //根据索引取得随机数加到code上
                code += random[index];
            }
            //把code值赋给验证码
            this.code = code;
        },
        sendMsg() {
            if(this.code !== this.form.code) {
                ShowMsg.call(this, '验证码不正确', 'error');
                this.createCode();
                return;
            };

            this.statrInterval();
            this.$get(this.getStore('confUrl') + '/viewsamplecheck', {
                mobile: this.mobile,
                guaranteeid: this.guaranteeid
            }, (data, res) => {
                ShowMsg.call(this, res.msg, 'success');
            });
        },
        statrInterval() {
            var sec = 10,
                that = this;
            this.msgBtnDisabled = true;
            clearInterval(this.interval);
            desHandler();
            this.interval = setInterval(desHandler, 1000);

            function desHandler () {
                if(sec === 0) {
                    clearInterval(that.interval);
                    that.msgBtnText = '获取短信验证码';
                    that.msgBtnDisabled = false;
                    return;
                };
                that.msgBtnText = sec + '秒后重试';
                sec--;
            }
        }
    },
    mounted: function () {
        this.createCode();
    }
}
